import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "Religious Practices",
    date: "15 August, 2025",
    admin: "Admin",
    heading: "Step-by-Step Guide to Performing Salah",
    content: "Learn the correct way to perform Salah and enhance your connection with Allah.",
    important: {
      content: "Discover the proper method of performing Salah, the most important act of worship in Islam. From making wudu to the final salaam, learn each step to strengthen your faith and fulfill your daily obligation.",
      intro: "Islamic Scholar"
    },
    paragraph: {
      para1: "Salah is one of the five pillars of Islam, serving as a direct link between a believer and Allah. It is performed five times a day, helping Muslims maintain discipline, humility, and mindfulness.",
      para2: "Before performing Salah, one must make wudu (ablution) to ensure physical and spiritual purity. Facing the Qibla, Muslims begin with the Takbir and recite verses from the Quran, accompanied by specific physical movements.",
      para3: "Each movement and recitation in Salah carries deep meaning, reminding the worshipper of Allah’s mercy, guidance, and greatness. Proper concentration and sincerity are essential for a valid prayer.",
      para4: "Explore our gallery to learn the steps of Salah visually, from the opening Takbir to the concluding Tasleem, ensuring your prayer is performed correctly and with devotion."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2
    ],
    tags: ["Salah", "Guide", "Prayer"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "Olivia Williams",
        date: "25 March, 2025",
        content: "This guide is so helpful! I’ve been looking for a clear explanation of Salah steps.",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Alexander Smith",
            date: "26 March, 2025",
            content: "Agreed! The visual references make it even easier to understand."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Christopher Brown",
        date: "26 March, 2025",
        content: "Very informative. This will help me teach my kids how to pray properly."
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "Spiritual Teachings",
    date: "10 August, 2025",
    admin: "Admin",
    heading: "The Spiritual and Social Importance of Ramadan",
    content: "Explore the significance of Ramadan and how it transforms hearts and communities.",
    important: {
      content: "Ramadan is more than just fasting; it is a month of self-discipline, spiritual growth, and deep reflection. It strengthens faith, unites communities, and fosters compassion for those in need.",
      intro: "Islamic Scholar"
    },
    paragraph: {
      para1: "Ramadan, the ninth month of the Islamic calendar, holds great significance for Muslims worldwide. It is a time dedicated to fasting from dawn to sunset, accompanied by increased acts of worship, prayer, and charity.",
      para2: "Fasting during Ramadan teaches self-control, patience, and empathy towards the less fortunate. It also serves as a reminder of the blessings we often take for granted, fostering a greater sense of gratitude.",
      para3: "Beyond the physical abstention from food and drink, Ramadan is about purifying the soul, refraining from negative behavior, and seeking forgiveness from Allah.",
      para4: "From the shared iftar meals to nightly Taraweeh prayers, Ramadan strengthens the bonds between families and communities while encouraging acts of kindness and generosity."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2
    ],
    tags: ["Ramadan", "Spiritual", "Islamic"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Fatima Khan",
        date: "25 March, 2025",
        content: "This beautifully explains why Ramadan is such a cherished time for Muslims.",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Omar Ali",
            date: "26 March, 2025",
            content: "Absolutely. It’s the perfect time to reset spiritually and reconnect with our Creator."
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Aisha Ahmed",
        date: "26 March, 2025",
        content: "Ramadan brings so much peace and joy to our hearts. Can't wait for the next one!"
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Quran Learning",
    date: "28 July, 2025",
    admin: "Admin",
    heading: "A Beginner’s Guide to Reading the Quran",
    content: "Learn the essential steps and etiquettes for reading the Holy Quran with understanding.",
    important: {
      content: "Reading the Quran is not just about reciting its words—it’s about connecting with its meaning, reflecting upon its guidance, and implementing its teachings in daily life.",
      intro: "Islamic Scholar"
    },
    paragraph: {
      para1: "The Quran, the final revelation from Allah, is a complete guide for humanity. Learning to read it correctly is a spiritual journey that requires sincerity, patience, and dedication.",
      para2: "Before beginning, one should perform ablution (wudu) to ensure physical purity. Sit in a clean and quiet place, handle the Quran with respect, and start by reciting 'Bismillah'.",
      para3: "Learning Tajweed rules is essential for correct pronunciation. Tajweed helps maintain the beauty and accuracy of the Quranic recitation as it was revealed to Prophet Muhammad ﷺ.",
      para4: "Reading with understanding is equally important. Studying translations and tafsir (exegesis) will deepen one’s connection with the words of Allah, enabling one to live by its guidance."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2
    ],
    tags: ["Quran", "Guide", "Islamic"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Muhammad Ali",
        date: "5 April, 2025",
        content: "Very helpful tips! I’m planning to start learning Tajweed soon.",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "Sara Yousuf",
            date: "6 April, 2025",
            content: "That’s great! It truly makes a difference in recitation."
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Hamza Khan",
        date: "7 April, 2025",
        content: "Beautifully written! Reading with meaning has changed my perspective on life."
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Life Purpose",
    date: "21 July, 2025",
    admin: "Admin",
    heading: "Why Islam Offers the Most Fulfilling Purpose in Life",
    content: "Discover how Islam provides a clear purpose for every aspect of a believer’s life.",
    important: {
      content: "Islam gives its followers a purpose rooted in worshiping Allah, serving humanity, and striving for eternal success in the Hereafter.",
      intro: "Islamic Scholar"
    },
    paragraph: {
      para1: "Every human seeks meaning and direction in life. Islam provides a comprehensive purpose that balances spiritual, moral, and worldly responsibilities.",
      para2: "The central purpose in Islam is to worship Allah alone and live according to His guidance, as revealed in the Quran and demonstrated by Prophet Muhammad ﷺ.",
      para3: "This divine purpose gives clarity in decision-making, peace in times of hardship, and motivation to strive for excellence in all areas of life.",
      para4: "Unlike temporary worldly goals, Islam’s purpose extends beyond this life, promising eternal reward for those who live righteously and fulfill their duties towards Allah and creation."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2
    ],
    tags: ["Purpose", "Islamic", "Spiritual"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Ayesha Noor",
        date: "10 April, 2025",
        content: "This really inspired me to reflect on my daily intentions.",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "Bilal Ahmad",
            date: "11 April, 2025",
            content: "Same here! It reminded me why faith should guide every decision."
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Omar Siddiqui",
        date: "12 April, 2025",
        content: "Beautifully explained! Islam truly provides a complete way of life."
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Islamic Guidance",
    date: "12 July, 2025",
    admin: "Admin",
    heading: "Understanding the Islamic Lifestyle",
    content: "Explore how Islam shapes a balanced life that combines devotion, values, and practices.",
    important: {
      content: "The Islamic lifestyle is a complete way of life guided by the Quran and Sunnah, influencing worship, relationships, ethics, and daily habits.",
      intro: "Islamic Scholar"
    },
    paragraph: {
      para1: "Islamic lifestyle refers to living in accordance with the teachings of Islam in every aspect of life — from personal conduct to community interaction.",
      para2: "It emphasizes regular worship, honesty, compassion, and justice, while also encouraging healthy living, modesty, and balance between worldly and spiritual duties.",
      para3: "Daily actions such as eating halal food, dressing modestly, maintaining cleanliness, and avoiding harmful behavior are all integral to this way of life.",
      para4: "By following the Quran and the example of Prophet Muhammad ﷺ, Muslims can lead a purposeful life that benefits both the individual and society."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2
    ],
    tags: ["Lifestyle", "Islamic", "Guide"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Fatima Khan",
        date: "15 April, 2025",
        content: "A wonderful explanation of how Islam influences our daily lives.",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Ali Raza",
            date: "16 April, 2025",
            content: "Absolutely! It’s amazing how Islam provides guidance for even small matters."
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "Sara Ahmed",
        date: "17 April, 2025",
        content: "This really shows how Islam is a complete way of life."
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "Life Purpose",
    date: "5 July, 2025",
    admin: "Admin",
    heading: "Living Life with Purpose in Islam",
    content: "Discover how Islam guides us to live a life by balancing faith and self-growth.",
    important: {
      content: "Islam teaches that life is a trust from Allah, and every moment should be used in ways that bring benefit in this world and reward in the Hereafter.",
      intro: "Islamic Scholar"
    },
    paragraph: {
      para1: "In Islam, life is not just about survival but about fulfilling the purpose for which Allah created us — to worship Him and live by His guidance.",
      para2: "Muslims are encouraged to spend their time wisely, engaging in acts of worship, seeking knowledge, and performing good deeds.",
      para3: "Maintaining a balance between work, family, health, and spiritual duties is essential to lead a complete and peaceful life.",
      para4: "By remembering Allah in our daily routines and making every action an act of worship, life becomes a journey of purpose and contentment."
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2
    ],
    tags: ["Purpose", "Islamic", "Lifestyle"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Hassan Ali",
        date: "18 April, 2025",
        content: "This is a beautiful reminder to live consciously according to Islam.",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Maryam Siddiqui",
            date: "19 April, 2025",
            content: "True, every moment is an opportunity to please Allah."
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "Ahmed Raza",
        date: "20 April, 2025",
        content: "Very inspiring! I will try to implement these tips in my daily life."
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "Religious Practices",
    date: "23 June, 2025",
    admin: "Admin",
    heading: "Step-by-Step Guide to Performing Salah",
    content: "A detailed guide on how to perform Salah according to the Sunnah of the Prophet ﷺ.",
    important: {
      content: "Salah is the second pillar of Islam and the most important act of worship after the Shahadah. Performing it correctly ensures spiritual growth and closeness to Allah.",
      intro: "Islamic Scholar"
    },
    paragraph: {
      para1: "Salah begins with the intention (niyyah) in the heart, followed by Takbir al-Ihram (raising hands and saying 'Allahu Akbar').",
      para2: "Recite Surah Al-Fatiha and another Surah in the standing position, then perform Ruku (bowing) and Sujood (prostration) with humility.",
      para3: "Each prayer has a specific number of units (rak‘ahs), and proper order should be maintained from start to finish.",
      para4: "End the Salah with Tashahhud and Tasleem, sending peace upon the Prophet ﷺ and all believers."
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2
    ],
    tags: ["Salah", "Guide", "Prayer"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Ayesha Khan",
        date: "21 April, 2025",
        content: "Very helpful for new Muslims and for those looking to perfect their prayer.",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "Bilal Ahmed",
            date: "22 April, 2025",
            content: "Yes, step-by-step explanations are much easier to follow."
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Omar Farooq",
        date: "23 April, 2025",
        content: "May Allah accept all our prayers and keep us steadfast."
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Spiritual Teachings",
    date: "18 June, 2025",
    admin: "Admin",
    heading: "The Significance of Ramadan",
    content: "An in-depth look at why Ramadan holds a special place in Islam and hearts of Muslims.",
    important: {
      content: "Ramadan is the month in which the Qur'an was revealed, a time for fasting, reflection, and strengthening one’s connection with Allah.",
      intro: "Islamic Scholar"
    },
    paragraph: {
      para1: "Ramadan is the ninth month of the Islamic lunar calendar and is a blessed month of fasting from dawn to sunset.",
      para2: "It is a time for spiritual purification, self-discipline, and increased worship through Salah, Qur’an recitation, and charity.",
      para3: "Fasting in Ramadan is one of the Five Pillars of Islam, and it serves as a reminder of the struggles faced by those less fortunate.",
      para4: "The last ten nights of Ramadan hold even greater significance, especially Laylat al-Qadr, which is better than a thousand months."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2
    ],
    tags: ["Ramadan", "Spiritual", "Islamic"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Fatima Ali",
        date: "10 March, 2025",
        content: "Ramadan truly transforms the heart and soul.",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Yusuf Khan",
            date: "11 March, 2025",
            content: "Absolutely, it’s a spiritual recharge for the whole year."
          }
        ]
      },
      {
        id: 2,
        image: images.blog8Comment3,
        name: "Sara Malik",
        date: "12 March, 2025",
        content: "May Allah allow us to witness many more Ramadans."
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Quran Learning",
    date: "10 June, 2025",
    admin: "Admin",
    heading: "Learning to Recite the Quran",
    content: "A guide for beginners to improve Quran recitation with Tajweed.",
    important: {
      content: "Reciting the Qur'an with correct pronunciation and Tajweed is a form of worship and a way to connect deeply with Allah’s words.",
      intro: "Islamic Teacher"
    },
    paragraph: {
      para1: "The Qur'an is the divine word of Allah revealed to Prophet Muhammad ﷺ, and reciting it properly is an act of devotion.",
      para2: "Learning to recite begins with recognizing Arabic letters, understanding their sounds, and gradually practicing short Surahs.",
      para3: "Tajweed rules help preserve the correct pronunciation and rhythm, ensuring the recitation matches how it was revealed.",
      para4: "Regular practice, guidance from a qualified teacher, and listening to skilled reciters can greatly improve one’s fluency."
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2
    ],
    tags: ["Quran", "Guide", "Islamic"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Ahmed Raza",
        date: "15 March, 2025",
        content: "Learning Tajweed changed my understanding of the Qur'an.",
        replies: [
          {
            id: 1,
            image: images.blog9Comment2,
            name: "Maryam Siddiqui",
            date: "16 March, 2025",
            content: "Yes, it truly brings the words to life."
          }
        ]
      },
      {
        id: 2,
        image: images.blog9Comment3,
        name: "Bilal Khan",
        date: "17 March, 2025",
        content: "May Allah help us recite the Qur'an with sincerity."
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Life Purpose",
    date: "4 June, 2025",
    admin: "Admin",
    heading: "Why Islam Offers the Greatest Purpose",
    content: "An exploration of how Islam provides a complete purpose for life.",
    important: {
      content: "Islam defines life’s purpose as worshipping Allah, living righteously, and striving for eternal success in the Hereafter.",
      intro: "Islamic Scholar"
    },
    paragraph: {
      para1: "Every human being seeks meaning and direction in life. Without a clear purpose, life can feel empty and aimless.",
      para2: "Islam provides a divine framework, explaining our creation, responsibilities, and ultimate destination.",
      para3: "It teaches that our main purpose is to worship Allah alone, follow His guidance, and serve humanity with kindness and justice.",
      para4: "This purpose gives believers a moral compass, inner peace, and a vision that extends beyond this worldly life into eternity."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2
    ],
    tags: ["Purpose", "Islamic", "Spiritual"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Fatima Noor",
        date: "15 March, 2025",
        content: "Islam has given my life a clear direction and peace.",
        replies: [
          {
            id: 1,
            image: images.blog10Comment2,
            name: "Usman Ali",
            date: "16 March, 2025",
            content: "Absolutely, the purpose in Islam is unmatched."
          }
        ]
      },
      {
        id: 2,
        image: images.blog10Comment3,
        name: "Hassan Ahmed",
        date: "17 March, 2025",
        content: "Purpose in Islam connects both this life and the Hereafter."
      }
    ]
  }

];

export default blogs;